import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { faAddressBook, faClock, faCoffee, faEnvelope, faGlobe, faNewspaper, faPhone, faSms, faTablet } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { getFormApi } from '../dataObject/GetFormApi';
import { HelpService } from '../help-service';
 
@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css']
})
export class ContactusComponent implements OnInit {

  faPhone = faPhone;
  faMail = faEnvelope;
  faWeb = faGlobe;
  faClock = faClock;
  faWa = faSms;
  @ViewChild('msg') msgElement: ElementRef;
  Category: any = ['Product inquiry', 'Order inquiry','Change Email', 'Other']
  buttonSubmit: boolean;
  buttonLoading: boolean;
  submitted = false;

  constructor(private helpService: HelpService, public fb: FormBuilder, private toastr: ToastrService) { }


  complaintForm = this.fb.group({
    complaint: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    name: ['', Validators.required],
    phone: ['', [Validators.required, Validators.pattern("^((\\+62-?)|0)?[- +()0-9]+"),
    Validators.minLength(10), Validators.maxLength(15)]],
    category: ['', Validators.required],
    
  });
  getFormApi: getFormApi;
  ngOnInit(): void {

    this.buttonSubmit = true;
    this.buttonLoading = false;
  }

  get f() {
    return this.complaintForm.controls;
  }
  submitForm() {

    this.submitted=true;
    console.log(this.complaintForm.value);
    if (this.complaintForm.valid) {
      this.buttonSubmit = false;
      this.buttonLoading = true;

      this.helpService.postComplaint(this.complaintForm.value)
        .subscribe(data => {
          this.getFormApi = data;
          const statusresult = this.getFormApi.status;
          if (this.getFormApi.status === 1) {
            
            this.toastr.success(this.getFormApi.message)
            console.log(this.getFormApi.message);
            alert(this.getFormApi.message)
            this.reloadData();
            
          } else {
            
            this.toastr.error(this.getFormApi.message);
            alert(this.getFormApi.message)
            console.log(this.getFormApi.message);
          }
        }, error => {
          console.log(error)
        });
    } else {
      
      this.validate(this.complaintForm);
      if(this.complaintForm.value.complaint==''
      &&this.complaintForm.value.email!=''
      &&this.complaintForm.value.name!=''
      &&this.complaintForm.value.phone!=''){
        setTimeout(()=>{ // this will make the execution after the above boolean has changed
          this.msgElement.nativeElement.focus();
        },0);  
      }else{
        window.scroll(0,0);
        alert('Lengkapi data')
      }
    }



  }

  validate(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validate(control);            //{6}
      }
    });
  }

  reloadData() {
    window.location.reload();
  }

  changeCat(e) {
    console.log(e.value)
    this.category.setValue(e.target.value, {
      onlySelf: true
    })
  }

  get category() {
    return this.complaintForm.get('category');
  }
}
